import * as types from '../actions/ActionTypes.js';
import { isChinaUser } from '../utils/ChinaUtil';

const INITIAL_STATE = {
    isFetching: false,
    isFinished: false,
    finishStatus: {},
    entities: {}
};

const requestUserPreference = (state) => {
    return {
        ...state,
        isFetching: true,
        isFinished: false
    };
};

const receiveUserPreference = (state, action) => {
    return {
        ...state,
        isFetching: false,
        isFinished: true,
        entities: {
            ...state.entities,
            [action.preference.key]: action.preference.value
        },
        finishStatus: {
            ...state.finishStatus,
            [action.preference.key]: true
        },
        lastUpdated: action.receivedAt
    };
};

export const setUserPreference = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.preference.key]: action.preference.value
        }
    };
};

const handlers = {
    [types.REQUEST_USER_PREFERENCE]: requestUserPreference,
    [types.RECEIVE_USER_PREFERENCE]: receiveUserPreference,
    [types.SET_USER_PREFERENCE]: setUserPreference
};

export const getUserPreference = (state, key) => {
    return {
        key: [key],
        value: state.userPreference.entities[key] || null
    };
    // return {[key]: state.userPreference.entities[key]} || {[key]: null};
};

export const getMapProvider = (state, key) => {
    if (isChinaUser()) {
        return {
            key: [key],
            value: 'baidu'
        };
    }
    let mapProvider;
    if (state.userPreference.entities[key] === null) {
        mapProvider = 'google';
    }
    return {
        key: [key],
        value: state.userPreference.entities[key] || mapProvider
    };
};

export const getUserPreferenceValue = (state, key) => {
    return state.userPreference.entities[key] || null;
};

export const getUserPreferenceFinish = (state, key) => {
    return state.userPreference.finishStatus[key] || false;
};

export const getUserPreferenceIsFetching = (state) => {
    return state.userPreference.isFetching;
};

export default function userPreference(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
